import {
  isPromise
} from "./chunk-MBTBSBLB.mjs";

// src/index.async.ts
function onErrorResumeNext(fn, context) {
  return new Promise((resolve) => {
    try {
      const result = fn.call(context);
      if (isPromise(result)) {
        result.then(resolve, () => resolve(void 0));
      } else {
        resolve(result);
      }
    } catch {
      resolve(void 0);
    }
  });
}
export {
  onErrorResumeNext
};
//# sourceMappingURL=on-error-resume-next.async.mjs.map